export const profileTabconfig = {
    distributor: {
            fields: [
                {
                    label: "Contact Person",
                    number:2,
                    key:"1"
                },
                {
                    label: "Company Details",
                    number:3,
                    key:"2"
                },
                {
                    label: "Billing Details",
                    number:4,
                    key:"3"
                },
                {
                    label: "Company Authorized Details",
                    number:5,
                    key:"4"
                }
            ]
        }
        ,
        supplier: {
            fields: [
                {
                    label: "Contact Person",
                    number:2,
                    key:"1"
                },
                {
                    label: "Company Details",
                    number:3,
                    key:"2"
                },
                {
                    label: "Person Invoice",
                    number:4,
                    key:"3"
                }
            ]
        }
        }